
import React, { Component } from 'react';
import ThirdCom from './index';

/**
 * 显示属性包装组件
 */
class ShowWrapper extends Component {
    static defaultProps = { 
        show: false,
        visible: false,
        display: false,
    }

    render() {
        let { show, visible, display, properName } = this.props;
        let realProp = show;
        if(properName === 'visible'){
            realProp = visible;
        }else if(properName === 'display'){
            realProp = display;
        }
        return <ThirdCom
            {...this.props}
            showThirdComponent = {realProp}
        />;
    }
}

export default ShowWrapper;
